export const RETURN_POLICY = {
  merchantReturnLink: 'https://boosthive.eu/page/refund-policy',
  returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
  merchantReturnDays: 14,
  returnFees: 'https://schema.org/FreeReturn',
  refundType: 'https://schema.org/FullRefund',
};



// WEBPACK FOOTER //
// ./components/JSON-LD/boosthiveSchema.js